import { Box, Typography, Stack } from "@mui/material";
import { BUILDING_TYPE_COLORS } from "@tracabois/components";

export interface MapLegendProps {
  buildingTypes: string[];
}

export const MapLegend = ({ buildingTypes }: MapLegendProps) => (
  <Box
    sx={{
      position: "absolute",
      bottom: 20,
      left: 20,
      backgroundColor: "white",
      borderRadius: 2,
      padding: 2,
      boxShadow: 2,
      zIndex: 1000,
      maxWidth: 200,
    }}
  >
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      Types de bâtiments
    </Typography>
    <Stack spacing={0.5}>
      {buildingTypes.map((type) => (
        <Box key={type} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: BUILDING_TYPE_COLORS[type] || "#999",
            }}
          />
          <Typography variant="caption">{type}</Typography>
        </Box>
      ))}
    </Stack>
  </Box>
);
